/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';


export interface OperatorePraticaCreationForm { 
    email: string;
    nome?: string;
    cognome?: string;
    authorities: Set<AuthorityType>;
    comuni_ids: Set<string>;
    authoritiesWhitelisted?: boolean;
}

